'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../../typings/tsd.d.ts" />
///<reference path="../../../bindings/agency-registration/API/Client/api.d.ts" />
var agencyRegistration;
(function (agencyRegistration) {
    var service;
    (function (service) {
        var SearchService = function () {
            /*@ngInject*/

            function SearchService($http, $q) {
                _classCallCheck(this, SearchService);

                this._$http = $http;
                this._$q = $q;
                this._api = new API.Client.DefaultApi(this._$http);
            }

            _createClass(SearchService, [{
                key: 'searchAgency',
                value: function searchAgency(request) {
                    return this._api.agenciesDocumentNumberGet(request).then(function (response) {
                        return response.data;
                    });
                }
            }]);

            return SearchService;
        }();

        service.SearchService = SearchService;
    })(service = agencyRegistration.service || (agencyRegistration.service = {}));
})(agencyRegistration || (agencyRegistration = {}));
angular.module('agencyRegistrationApp').service('SearchService', agencyRegistration.service.SearchService);